import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
/**
 * Used to redirect to default page inside router
 * @param props
 * @constructor
 */
export function Redirect(props) {
    var to = props.to;
    var navigate = useNavigate();
    useEffect(function () {
        navigate(to, {
            replace: true
        });
    }, [navigate]);
    return (_jsx(_Fragment, {}));
}
